import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, Clock, Facebook, Instagram } from 'lucide-react';
import { COMPANY_INFO } from '../data/content';

const Contact = () => {
  return (
    <section id="kontakt" className="py-24 bg-neutral-darkNavy text-white relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          {/* Contact Info */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-10 flex flex-col justify-center"
          >
            <div>
              <h2 className="text-primary-orange font-bold tracking-wider uppercase mb-3">Kontakt</h2>
              <h3 className="text-4xl md:text-5xl font-bold mb-6">Stojimo vam na raspolaganju</h3>
              <p className="text-gray-400 text-lg leading-relaxed">
                Pozovite nas ili nas posetite. Naš tim je spreman da odgovori na sva vaša pitanja i dogovori termin koji vama najviše odgovara.
              </p>
            </div>

            <div className="space-y-8">
              <div className="flex items-start group">
                <div className="w-14 h-14 bg-primary-blue rounded-full flex items-center justify-center flex-shrink-0 mr-6 group-hover:scale-110 transition-transform duration-300">
                  <Phone className="text-white w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-bold text-xl mb-1">Telefon</h4>
                  <a href={`tel:${COMPANY_INFO.phone.replace(/\s/g, '')}`} className="text-gray-300 text-lg hover:text-primary-orange transition-colors">
                    {COMPANY_INFO.phone}
                  </a>
                </div>
              </div>
              
              <div className="flex items-start group">
                <div className="w-14 h-14 bg-primary-blue rounded-full flex items-center justify-center flex-shrink-0 mr-6 group-hover:scale-110 transition-transform duration-300">
                  <MapPin className="text-white w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-bold text-xl mb-1">Adresa</h4>
                  <a href={COMPANY_INFO.mapUrl} target="_blank" rel="noopener noreferrer" className="text-gray-300 text-lg hover:text-primary-orange transition-colors">
                    {COMPANY_INFO.address}
                  </a>
                  <p className="text-sm text-gray-500 mt-1">Kliknite za mapu</p>
                </div>
              </div>

              <div className="flex items-start group">
                <div className="w-14 h-14 bg-primary-blue rounded-full flex items-center justify-center flex-shrink-0 mr-6 group-hover:scale-110 transition-transform duration-300">
                  <Clock className="text-white w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-bold text-xl mb-1">Radno Vreme</h4>
                  <p className="text-gray-300 text-lg">Pon - Sub: 09:00 - 18:00</p>
                  <p className="text-gray-500">Nedelja: Neradno</p>
                </div>
              </div>
            </div>

            <div className="pt-8 border-t border-white/10">
              <h4 className="font-bold text-lg mb-4">Pratite nas</h4>
              <div className="flex gap-4">
                <a 
                  href={COMPANY_INFO.social.facebook} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary-blue transition-colors"
                >
                  <Facebook />
                </a>
                <a 
                  href={COMPANY_INFO.social.instagram} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary-orange transition-colors"
                >
                  <Instagram />
                </a>
              </div>
            </div>
          </motion.div>

          {/* Map */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="h-[500px] bg-gray-800 rounded-3xl overflow-hidden shadow-2xl border border-white/10 relative group"
          >
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2808.549639607263!2d19.8335493!3d45.2516667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b10613de93455%3A0x91f8d099921e694!2sJano%C5%A1ikova%2011a%2C%20Novi%20Sad!5e0!3m2!1sen!2srs!4v1629890000000!5m2!1sen!2srs" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen 
              loading="lazy"
              className="grayscale group-hover:grayscale-0 transition-all duration-500"
            ></iframe>
            
            {/* Overlay for interaction hint */}
            <a 
              href={COMPANY_INFO.mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-colors"
              title="Otvori u Google Mapama"
            ></a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
